var _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigibyte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#006ad1;}.cls-4{fill:#007fe8;}.cls-5{fill:#fdfefe;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tron"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_51",
    "data-name": "Layer 51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    className: "cls-3",
    width: 30,
    height: 30,
    rx: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_1",
    "data-name": "Intersection 1",
    className: "cls-4",
    d: "M0,7A7,7,0,0,1,7,0h6.47a16.39,16.39,0,0,1,.81,5.1A16.32,16.32,0,0,1,0,21.29Z"
  })))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M11.64,23.66l.44-1.17-.72.07c-.07,0-.08.05-.09.1-.1.24-.18.48-.28.72a.36.36,0,0,1-.41.28c-.52,0-1,0-1.56,0-.11,0-.14,0-.09-.14.11-.28.21-.57.31-.86a2.19,2.19,0,0,0-.36,0c-.49,0-1,0-1.46-.07-.13,0-.13,0-.09-.16C7.9,20.94,8.47,19.47,9.05,18q1-2.49,2-5c.11-.28,0-.23.33-.23h2.9a.41.41,0,0,1,.42.6L14,15.32l-1.56,4.17,0,.08c-.06.11,0,.13.1.13A7.67,7.67,0,0,0,15.42,19a7.11,7.11,0,0,0,3.06-2.89,6.32,6.32,0,0,0,.87-2.29,1.86,1.86,0,0,0-.5-1.81,2.18,2.18,0,0,0-1.39-.56H7.36c-.18,0-.19,0-.1-.16L8.51,9a.7.7,0,0,1,.66-.37h5.2a.17.17,0,0,0,.2-.14c.15-.41.31-.81.45-1.22a.14.14,0,0,1,.16-.1h1.53c.25,0,.32.11.24.35s-.24.65-.37,1c0,.11,0,.14.09.13h.47a.16.16,0,0,0,.19-.12c.14-.39.3-.77.43-1.16A.23.23,0,0,1,18,7.2h1.44c.29,0,.36.1.26.38s-.24.65-.37,1c0,.11,0,.16.1.17a6.86,6.86,0,0,1,2.18.6A3.41,3.41,0,0,1,23.37,11a3.6,3.6,0,0,1,.26,1.78,8.27,8.27,0,0,1-.92,2.94A10.56,10.56,0,0,1,19,20.08,13.54,13.54,0,0,1,14.65,22a.67.67,0,0,0-.57.52c-.09.29-.21.58-.32.87a.36.36,0,0,1-.41.28Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigibyte);
export default __webpack_public_path__ + "static/media/digibyte.159574dcc33b5d14a7d9eb2c0751ff15.svg";
export { ForwardRef as ReactComponent };